import React from 'react';

function CheckmarkSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      fill="none"
      viewBox="0 0 14 12"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.5 1.5l-8 9-3-3"
      ></path>
    </svg>
  );
}

export default CheckmarkSvg;
